/* eslint-disable no-param-reassign */
import { produce } from 'immer';

export default (set, get, visualizerMetaDataAndChoiceId) => {
  const { metadata: { Sku: sku = null }, choiceId } = visualizerMetaDataAndChoiceId;

  return set(produce(get(), (draft) => {
    if (!draft.design) {
      draft.design = {};
    }
    draft.design.selectedProduct = {
      itemId: sku,
      choiceId
    };
    // always reset selected visualized stack when selecting from configurator
    draft.design.selectedVisualizerStackId = null;
  }), false, {
    type: 'SELECT',
    payload: {
      itemId: sku,
      choiceId
    }
  });
};
